// General errors: https://eips.ethereum.org/EIPS/eip-1193#provider-errors

export const enum WalletProviderError {
  CHAIN_NOT_ADDED = 4902,
}
